import * as Factory from 'factory.ts'
import faker from 'faker'

import { type SegmentAnalyticsMetadata } from '@webapp/models/SegmentAnalyticsMetadata'

const SegmentAnalyticsUserMetadataMock = Factory.Sync.makeFactory(() => {
  const groupId = faker.random.uuid()
  const firstName = faker.name.firstName()
  const lastName = faker.name.lastName()

  return {
    groupId,
    name: `${firstName} ${lastName}`,
    first_name: firstName,
    last_name: lastName,
    position: faker.name.jobTitle(),
    email: faker.internet.email(),
    domain: faker.internet.domainName(),
    company: faker.company.companyName(),
    unique_id: faker.random.uuid(),
    is_superuser: false,
    'Has Request Access': true,
    'Has Approval Access': false,
    'Has Procure Access': false,
    'Has Receive Access': false,
    'Has Payment Access': false,
    'Has Accounts Payable Access': false,
    'Has Reports Access': false,
    'Has Settings Access': false,
  }
})

const SegmentAnalyticsUserMock = Factory.Sync.makeFactory(() => ({
  id: faker.random.uuid(),
  metadata: SegmentAnalyticsUserMetadataMock.build(),
}))

const SegmentAnalyticsGroupMock = Factory.Sync.makeFactory(() => ({
  id: faker.random.uuid(),
  metadata: {
    name: faker.company.companyName(),
  },
}))

export const SegmentAnalyticsMetadataMock =
  Factory.Sync.makeFactory<SegmentAnalyticsMetadata>(() => {
    const groupId = faker.random.uuid()
    const company = faker.company.companyName()

    return {
      user: SegmentAnalyticsUserMock.build({
        metadata: SegmentAnalyticsUserMetadataMock.build({
          groupId,
          company,
        }),
      }),
      group: SegmentAnalyticsGroupMock.build({
        id: groupId,
        metadata: {
          name: company,
        },
      }),
    }
  })
